import React from 'react';

const FormGroupWrapper = ({ children, labelTitle, reactSelectClass = '' }) => {
	return (
		<div className="single-flied-item">
			<div className={`form-group ${reactSelectClass}`}>
				<label htmlFor="collection">{labelTitle}</label>
				{children}
			</div>
		</div>
	);
};

export default FormGroupWrapper;
